export const ArrayMerge = (a, b, predicate = (a, b) => a === b, updateFunction = (a, b) => {}) => {
    if (!a || !b || !Array.isArray(a) || !Array.isArray(b)) {
        throw new TypeError();
    }

    const c = [...a]; // copy to avoid side effects

    // add all items from B to copy C if they're not already present
    // if the item already exists in C, update it using the provided updateFunction
    b.forEach((bItem) => {
        const cItem = c.find((cItem) => predicate(bItem, cItem));

        if (cItem) {
            updateFunction(bItem, cItem);
        } else {
            c.push(bItem);
        }
    });

    return c;
};